<template>
    <el-dialog
        width='600px'
        :title="translate('delete_warehouse_modal.title')"
        :visible.sync='show'
        :close-on-click-modal='false'
        :before-close='close'
    >
        <el-form class="content" v-if="!validating">
            <p v-if="blocked" class="delete-warehouse-modal__blocked">
                {{ blockedMessage }}
            </p>

            <p v-else>
                {{ requiresReason
                    ? translate('delete_warehouse_modal.warning_text')
                    : translate('delete_warehouse_modal.confirm_text') }}
            </p>

            <div v-if="!blocked && requiresReason" style="margin-top: 12px;">
                <el-form-item>
                    <span>{{ translate('delete_warehouse_modal.reason_label') }}</span>
                    <el-input
                        type="textarea"
                        :rows="4"
                        v-model="reason"
                        :placeholder="translate('delete_warehouse_modal.reason_placeholder')"
                    />
                </el-form-item>
            </div>

            <div class="actions" style="margin-top: 20px; text-align: right;">
                <el-button @click="close">
                    {{ blocked
                        ? translate('delete_warehouse_modal.close_button')
                        : translate('delete_warehouse_modal.cancel_button') }}
                </el-button>
                <el-button
                    v-if="!blocked"
                    type="primary"
                    style="margin-left: 10px;"
                    :loading="deleting"
                    @click="confirmDeletion"
                >
                    {{ translate('delete_warehouse_modal.confirm_button') }}
                </el-button>
            </div>
        </el-form>
    </el-dialog>
</template>

<script>
import warehouseService from '@/services/ArmazemModuleService';

const MIN_REASON_LENGTH = 3;

export default {
    name: 'deleteWarehouseModal',
    props: {
        show: {
            type: Boolean,
            required: true
        },
        warehouse: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            reason: '',
            validating: true,
            deleting: false,
            blocked: false,
            blockedMessage: '',
            requiresReason: false
        };
    },
    mounted() {
        this.validateDeletion();
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        translateBackendMessage(code) {
            const key = `delete_warehouse_modal.${code}`;
            const message = this.translate(key);
            return message === `warehouse.${key}`
                ? this.translate('delete_warehouse_modal.error_message')
                : message;
        },
        async validateDeletion() {
            this.validating = true;
            try {
                const { data } = await warehouseService.validateWarehouseDeletion(this.warehouse.id);
                this.blocked = !data.podeExcluir;
                this.requiresReason = data.exigeJustificativa;
                this.blockedMessage = this.blocked
                    ? this.translateBackendMessage(data.motivoBloqueio)
                    : '';
            } catch (error) {
                this.$notify.error({
                    message: this.translateBackendMessage(error?.response?.data?.message),
                    duration: 6000
                });
                this.close();
            } finally {
                this.validating = false;
            }
        },
        async confirmDeletion() {
            const reason = this.reason ? this.reason.trim() : '';

            if (this.requiresReason && reason.length < MIN_REASON_LENGTH) {
                this.$notify.error({ message: this.translate('delete_warehouse_modal.reason_error_message') });
                return;
            }

            this.deleting = true;
            try {
                await warehouseService.deleteWarehouse(this.warehouse.id, reason);
                this.$notify.success({
                    message: this.translate('delete_warehouse_modal.success_message'),
                    duration: 6000
                });
                this.$emit('confirm');
                this.close();
            } catch (error) {
                this.$notify.error({
                    message: this.translateBackendMessage(error?.response?.data?.message),
                    duration: 6000
                });
            } finally {
                this.deleting = false;
            }
        },
        close() {
            this.reason = '';
            this.$emit('close');
        }
    }
};
</script>

<style scoped lang="scss">
.delete-warehouse-modal__blocked {
    color: #c0392b;
}
</style>
